<script>
    import Container from './Container.svelte';
    import Button from './General/Button.svelte';
    import Grid from './Grid.svelte';
    import Icon from './General/Icon.svelte';
    import { dataStore, style, vehicle_type } from '../lib/store';
    import { getFilters, performSearch } from '../lib/api';
    import { translate } from '../lib/translate';

    console.log(vehicle_type);

    const filterCodes = {
        brand: 'bd',
        brandType: 'bt',
        cabinType: 'ct',
        superStructureMix: 'sup',
        gearbox: 'gb',
    };

    // Fields to exclude when getting all filter fields from the api.
    const excludeFields = ([key]) => ![
        'features',
        'totalCount',
        'countries',
        'year',
        'km',
        'price',
        'options',
        'sellerBuyOption',
        'hp',
        'fuel',
        'configuration',
        'axleBrand',
        'axleAmount',
        'generalOptions',
        'superStructureFacets',
        'superStructureOptions',
    ].includes(key);

    let fields = [];

    function getFields() {
        getFilters($dataStore.filters).then(data => fields = data.response);
    }
</script>

<header class={style}>
    <Container>
        <div class="text-center">
            <h1>{translate('Lagerhofbestand')}</h1>
            <p>{translate('Treffen Sie Ihre Wahl mit den folgenden Filter')}</p>
        </div>
        <div class="filter-group">
            <Grid columns={[1, 2, 3]} gapx={31}>
                <div class="select-box">
                    <select
                        bind:value={$dataStore.filters.vt}
                        on:change={() => {
                        getFields();
                        dataStore.update(store => ({
                        ...store,
                        filters: {
                        ...store.filters,
                        bd:  null,
                        bt:  null,
                        ct:  null,
                        gb:  null,
                        sup: null,
                        }
                        }));
                        }}
                    >   

                        <option value={null}>{translate('vehicle_type_s')}</option>
                        {#each vehicle_type as type}
                            <option value={type.id}>{type.label}</option>
                        {/each}
                    </select>
                    <div class="icon">
                        <Icon name="CHEVRON_DOWN" size={13} />
                    </div>
                </div>
                {#if $dataStore.filters.vt !== null}
                    {#each Object.entries(fields).filter(excludeFields) as [name, options]}
                        <div class="select-box">
                            <select
                                name={Math.random()}
                                id={Math.random()}
                                bind:value={$dataStore.filters[filterCodes[name]]}
                                on:change={getFields}
                            >
                                <option value={null}>{translate(name)}</option>
                                {#each options as option}
                                    {#if option.hasOwnProperty('key')}
                                        <option value={option.key}>{translate(option.key)}</option>
                                    {:else}
                                        <option value={option.value}>{translate(option.value)}{name === 'weights' && 'kg'}</option>
                                    {/if}
                                {/each}
                            </select>
                            <div class="icon">
                                <Icon name="CHEVRON_DOWN" size={13} />
                            </div>
                        </div>
                    {/each}
                {:else}
                    <!-- Filter is Disabeld first load -->
                    <div class="select-box">
                        <select
                            name={Math.random()}
                            id={Math.random()}
                            bind:value={$dataStore.filters[filterCodes[name]]}
                            on:change={getFields}
                            disabled
                        >
                            <option value={null}>{translate('Modell')}</option>
                        </select>
                        <div class="icon">
                            <Icon name="CHEVRON_DOWN" size={13} />
                        </div>
                    </div>
                    <div class="select-box">
                        <select
                            name={Math.random()}
                            id={Math.random()}
                            bind:value={$dataStore.filters[filterCodes[name]]}
                            on:change={getFields}
                            disabled
                        >
                            <option value={null}>{translate('Kabine')}</option>
                        </select>
                        <div class="icon">
                            <Icon name="CHEVRON_DOWN" size={13} />
                        </div>
                    </div>
                    <div class="select-box">
                        <select
                            name={Math.random()}
                            id={Math.random()}
                            bind:value={$dataStore.filters[filterCodes[name]]}
                            on:change={getFields}
                            disabled
                        >
                            <option value={null}>{translate('Überbau')}</option>
                        </select>
                        <div class="icon">
                            <Icon name="CHEVRON_DOWN" size={13} />
                        </div>
                    </div>
                    <div class="select-box">
                        <select
                            name={Math.random()}
                            id={Math.random()}
                            bind:value={$dataStore.filters[filterCodes[name]]}
                            on:change={getFields}
                            disabled
                        >
                            <option value={null}>{translate('Aufbau')}</option>
                        </select>
                        <div class="icon">
                            <Icon name="CHEVRON_DOWN" size={13} />
                        </div>
                    </div>
                    <div class="select-box">
                        <select
                            name={Math.random()}
                            id={Math.random()}
                            bind:value={$dataStore.filters[filterCodes[name]]}
                            on:change={getFields}
                            disabled
                        >
                            <option value={null}>{translate('Getriebegehäuse')}</option>
                        </select>
                        <div class="icon">
                            <Icon name="CHEVRON_DOWN" size={13} />
                        </div>
                    </div>
                {/if}
            </Grid>
        </div>
        <div class="submit">
            <Button
                text={translate('Zoeken')}
                action={performSearch}
                icon="ARROW_RIGHT"
                fluid
                large
            />
        </div>
    </Container>
</header>

<style type="text/scss" lang="scss">
    header {
        padding: 128px 0 96px;
        background-color: var(--c-primary);
    }

    h1, p {
        color: white;
    }

    h1 {
        line-height: 58px;
        font-weight: 700;
        font-size: 36px;
        + p {
            font-weight: 600;
            margin-top: -6px;
            line-height: 31px;
            text-align: center;
        }
    }

    .filters {
        margin-bottom: 22px;
    }

    .filter-group {
        margin-top: 69px;
        margin-bottom: -22px;
        justify-content: center;

        @media (max-width: 599px) {
            margin-bottom: -10px;
        }
    }

    .submit {
        margin: 21px auto 0;
        @media (min-width: 1200px) {
            width: calc((100% / 3) - 20px);
        }
    }

    .select-box {
        position: relative;
        margin-bottom: 22px;
        @media (max-width: 599px) {
            margin-bottom: 10px;
        }
    }

    select {
        width: 100%;
        height: 56px;
        padding: 0 25px;
        font-weight: 600;
        color: #444;
        appearance: none;
        -webkit-appearance: none;
        border-radius: 0;
        background-color: #FFF;
        cursor: pointer;
        border: 0;

        @media (max-width: 599px) {
            padding: 0 21px;
        }

        &:disabled {
            opacity: .6;
            cursor: not-allowed;
        }
    }

    .icon {
        position: absolute;
        height: 100%;
        display: flex;
        align-items: center;
        top: 0;
        right: 28px;
        pointer-events: none;

        @media (max-width: 599px) {
            right: 22px;
        }
    }

    // Style overwrites
    
</style>
